
<div>
  <div v-if="user" class="header">
    <div class="container">
      <div class="header-content">
        <avatar v-if="user.photoUrl" :image-url="user.photoUrl" />

        <div>
          <h1 class="secondary-font">
            {{ user.displayName || 'Anonymous' }}
          </h1>

          <align>
            <pro-label />

            <icon-button
              v-if="!!profileLink"
              tooltip="Message owner"
              icon="question_answer"
              as="a"
              target="_blank"
              :href="profileLink"
            />
          </align>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <spinner v-if="loading" />

    <div v-else class="tabs">
      <tab
        v-for="collection in collections"
        :key="collection.id"
        as="router-link"
        :to="`/showcase/${collection.uid}?collectionId=${collection.id}`"
        :active="collection.id === $route.query.collectionId"
      >
        {{ collection.name }}
      </tab>
    </div>

    <showcase-collection-view
      v-if="$route.query.collectionId"
      v-show="!loading"
      :collection-id="$route.query.collectionId"
    />
  </div>
</div>
